<template>
	<div class="PageBox">
		<div class="page_box">
			<div id="page_turn_box">
				<li v-for="(item,index) in pageBoxData" :key='index'>
					<router-link :to='item.Url' :class="[ (pageIndex==item.Nab ||(!pageIndex&&item.Nab==1))?'on':'']"  >{{item.Name}}</router-link>
				</li>    
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'PageBox',
		props:{
			pageBoxData:{
				type: Object,
				default: () => {}
			},
			pageIndex: {
			   type:Number,
			   default: 1
			 }
		}
	}
</script>

<style lang="less" scoped="scoped">
	.page_box {
		li{
			margin: 0 0.1rem;
			a{
				font-size: 0.18rem;
				font-weight: normal;
				font-stretch: normal;
				letter-spacing: 0.02rem;
				color: #333333;
			}
			a.on{
			  color: #0376be;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/pageBox.vue